import {
  Box,
  IconCopy,
  IconTick,
  IconVisibility,
  Inline,
  Text,
} from 'braid-design-system';
import { useState } from 'react';
import { InlineCode } from 'scoobie';
import { useElementPosition } from '#src/hooks/ElementPositionProvider.tsx';
import { useTracking } from '#src/hooks/tracking/TrackingProvider.tsx';

export const Secret = ({
  secret,
  label,
}: {
  secret: string;
  label: string;
}) => {
  const [revealed, setRevealed] = useState(false);
  const [copied, setCopied] = useState(false);
  const elementPosition = useElementPosition();
  const { trackLink } = useTracking();

  const copyText = async () => {
    if (copied) {
      return;
    }

    setCopied(true);

    await navigator.clipboard.writeText(secret);

    trackLink({
      eventName: 'developer_site_element_pressed',
      data: {
        elementAction: 'copy',
        elementText: 'icon',
        elementPosition,
        elementDesign: 'button',
      },
    });

    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <Text size="small" weight="medium">
        {label}
      </Text>
      <Inline space="xsmall" alignY="top">
        <Text size="small">
          <InlineCode>{revealed ? secret : '•'.repeat(35)}</InlineCode>
        </Text>
        <Box
          onClick={() => {
            setRevealed((prev) => {
              trackLink({
                eventName: 'developer_site_element_pressed',
                data: {
                  elementAction: prev ? 'hidden' : 'revealed',
                  elementText: 'icon',
                  elementPosition,
                  elementDesign: 'button',
                },
              });
              return !prev;
            });
          }}
          cursor="pointer"
          title="Reveal"
        >
          <Text>
            <IconVisibility tone="link" />
          </Text>
        </Box>
        <Box
          component="span"
          cursor="pointer"
          onClick={copyText}
          title="Copy to Clipboard"
        >
          <Text>
            {copied ? <IconTick tone="positive" /> : <IconCopy tone="link" />}
          </Text>
        </Box>
      </Inline>
    </>
  );
};
